// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnalyzeMyResume_wrapper__TN3pA","pending-analysis":"AnalyzeMyResume_pending-analysis__hmnIQ"};